import clsx from 'clsx';
import React, { useEffect } from 'react';
import {
  useLocation,
  useRouteMatch,
  useHistory,
  Switch,
  Route,
  matchPath,
} from 'react-router';
import { Link } from 'react-router-dom';

import Icon, { ICONS } from '../common/Elements/Icon/Icon';
import { LEGAL_INFORMATION_CENTER_ROUTES } from '../legalInformationCenter/routes';

import '../legalInformationCenter/index.scss';

const LegalInformationPage = () => {
  const location = useLocation();
  const match = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    if (!matchPath(match.path, location.pathname)) return;
    history.push(
      `${match.path}/${LEGAL_INFORMATION_CENTER_ROUTES[0].pathname}`
    );
  }, []);

  return (
    <div className="tw-h-screen legal-information-center">
      <div className="tw-flex tw-items-center tw-px-[20px] tw-py-[12px] tw-border-b tw-border-cfo-grey-500/50">
        <Icon icon={ICONS.company_logo()} />
        <h1 className="tw-text-cfo-blue-600 tw-text-[18px] tw-ml-[10px] tw-font-brandonTextMedium">
          Legal Information Center
        </h1>
      </div>
      <div className="tw-flex tw-h-[calc(100vh-56px)]">
        <div className="tw-min-w-[300px] tw-py-[20px] tw-border-r tw-border-cfo-grey-500">
          <ul>
            {LEGAL_INFORMATION_CENTER_ROUTES.map((route, index) => (
              <li key={index}>
                <Link to={`${match.path}/${route.pathname}`}>
                  <div
                    className={clsx(
                      'tw-py-[5px] tw-px-[20px] tw-font-brandonTextMedium',
                      location.pathname === `${match.path}/${route.pathname}` &&
                        'tw-bg-[#F3F7FF] tw-text-cfo-blue-600'
                    )}
                  >
                    {route.label}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <Switch>
          {LEGAL_INFORMATION_CENTER_ROUTES.map((page, index) => (
            <Route
              path={`${match.path}/${page.pathname}`}
              key={index}
              render={(props) => <page.component {...props} isView={true} />}
            />
          ))}
        </Switch>
      </div>
    </div>
  );
};

export default LegalInformationPage;
